import * as React from 'react';
import { Tooltip } from '@cian/ui-kit/tooltip';

import * as styles from './PlatformsLink.css';
import { plural } from '@cian/utils';

interface IProps {
  platforms: string[];
}

export function PlatformsLink({ platforms }: IProps) {
  const tooltipTitle = <div className={styles['popup-text']}>{platforms.join(', ')}</div>;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <Tooltip title={tooltipTitle} theme="white" placement="right">
      <a className={styles['dashed']} href="#" onClick={handleClick}>
        {`${platforms.length} ${plural(platforms.length, ['площадке', 'площадках', 'площадках'])}`}
      </a>
    </Tooltip>
  );
}
